module.exports = __webpack_public_path__ + "ad28af482585d560cf4aeeaf781a7438.jpg";